<template>
  <div class="add-attr-name public-content">
    <div class="breadcrumb" style="background: #fff">添加属性值</div>
    <div class="order-detail-basic">
      <el-form :model="attrData" label-width="100px">
        <el-form-item label="属性值:" prop="name">
          <el-input v-model="attrData.propVal" placeholder="请输入" ref="iptRef" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="checkRepeat">确定</el-button>
    </div>
  </div>
</template>
 <script>
import { dictGet, dictAdd, dictUpdate, dictUsable } from '@/api/pms'
export default {
  name: 'AddAttrName',
  data () {
    return {
      attrData: {
        parentId: this.$route.query.parentId,
        propKey: '',
        propVal: '',
        propUrl: '',
        isMallShow: ''
      }
    }
  },
  created () {
    this.getPrimaryAttr()
  },
  methods: {
    // 获取属性详情
    getPrimaryAttr () {
      dictGet(this.$route.query.id).then((res) => {
        if (res.data.success) {
          this.attrData.isMallShow = res.data.data.isMallShow
          this.attrData.propKey = res.data.data.propKey
          this.attrData.propVal = res.data.data.propVal
          if (this.$route.query.type === '1') {
            this.attrData.pid = this.$route.query.id
          }
          if (this.$route.query.type === '0') {
            this.attrData.pid = res.data.data.pid
          }
        }
      })
    },
    checkRepeat () {
      let name = {
        act: this.$route.query.type === '1' ? 0 : 1,
        dictName: this.attrData.propVal,
        dictId: this.$route.query.type === '1' ? null : this.$route.query.id,
        isVerifyKey: false
      }
      if (this.attrData.propVal === '') {
        this.$message.error('属性值不能为空')
        return false
      }
      dictUsable(name).then((res) => {
        if (res.data.success) {
          this.onsubmit()
        }
      })
    },
    onsubmit () {
      let _this = this
      if (this.$route.query.type === '1') {
        dictAdd(this.attrData).then((res) => {
          if (res.data.success) {
            this.$message.success('添加成功')
            this.$router.push('./attrmag')
          } else {
          }
        })
      }
      if (this.$route.query.type === '0') {
        dictUpdate({ dictId: this.$route.query.id, dictVo: this.attrData }).then((res) => {
          if (res.data.success) {
            this.$message.success('编辑成功')
            this.$router.push('./attrmag')
          } else {
          }
        })
      }
    }
  }
}
</script>
 <style scoped lang="less">
</style>
